import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  
  {
    path:'/kaoqinone',
    name:'"kao-qin-one',
    component: () => import('../views/kaoqin.vue')
  },
  {
    path:'/stu_dangan',
    name:'stu_dangan',
    component: () => import('../views/stu_info/stu_dangan.vue')
  },
  {
    path:'/stu_dangan',
    name:'stu_dangan',
    component: () => import('../views/stu_info/stu_dangan.vue')
  },
  {
    path:'/stu_dangan_shili',
    name:'stu_dangan_shili',
    component: () => import('../views/stu_info/stu_dangan_shili.vue')
  },
  {
    path:'/stu_dangan_zt',
    name:'stu_dangan_zt',
    component: () => import('../views/stu_info/stu_dangan_zt.vue')
  },
  {
    path:'/stu_dangan_tlyy',
    name:'stu_dangan_tlyy',
    component: () => import('../views/stu_info/stu_dangan_tlyy.vue')
  },
  {
    path:'/org_list',
    name:'org_list',
    component: () => import('../views/org_list.vue'),
	children: [{
			path: "stu_list",
			name: "stu_list",
			component: () => import("../views/stu_list.vue")
		},
		{
				path: "abc_a",
				name: "abc_a",
				component: () => import("../views/abc_a.vue")
			}]
  }
]
const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
